/*
  Form delivery uses the existing bearth.io Node application.
  - /api/capture is transactional contact mail via Hostinger SMTP.
  - /api/subscribe is a server-side proxy to Hostinger Reach. The browser never
    receives or stores the Hostinger API token.
*/

type CaptureResponse = { ok?: boolean; sent?: boolean; error?: string };

async function confirmed(res: Response): Promise<boolean> {
  const payload: CaptureResponse = await res.json().catch(() => ({}));
  return res.ok && payload.ok === true && payload.sent === true;
}

export type SubscribeResult = "pending" | "unavailable" | "failed";

export async function submitSubscribe(fields: {
  email: string;
  language: string;
  source: string;
  src?: string;
  consent: boolean;
  hp?: string;
  elapsed_ms?: number;
}): Promise<SubscribeResult> {
  try {
    const res = await fetch("/api/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(fields),
    });
    if (res.status === 503) return "unavailable";
    const payload: { ok?: boolean; pending?: boolean } = await res.json().catch(() => ({}));
    if (res.ok && payload.ok === true && payload.pending === true) return "pending";
    return "failed";
  } catch {
    return "failed";
  }
}

export async function submitCapture(fields: Record<string, string>): Promise<boolean> {
  try {
    const res = await fetch("/api/capture", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(fields),
    });
    if (await confirmed(res)) return true;
  } catch {
    /* continue to proven PHP fallback for legacy Hostinger serving mode */
  }

  try {
    const fd = new FormData();
    for (const [k, v] of Object.entries(fields)) fd.append(k, v);
    const res = await fetch("/api/capture.php", {
      method: "POST",
      body: fd,
      headers: { Accept: "application/json" },
    });
    if (await confirmed(res)) return true;
  } catch {
    /* both paths failed */
  }

  return false;
}
